import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { GetInPaymentConfirmationActionContext } from "./GetInPaymentConfirmationActionContext";
import index from "@beeldit/core/services";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";

function useGetInPayment() {
  const { setCount } = useContext(GetInPaymentConfirmationActionContext);
  const errorHandler = useErrorHandler();
  const { user } = useContext(AuthContext);

  return (
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    if (!user) {
      return;
    }
    let model;
    if (user.role === "producer" || user.role === 'dealer') {
      model = 'orders'
    } else if (user.role === "admin") {
      model = 'super-orders'
    }
    index(
      `${model}/countInPaymentConfirmation`,
    )
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setCount(data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGetInPayment;
